@property --dc-border-angle {
  syntax: '<angle>';
  initial-value: 0deg;
  inherits: false;
}

.extracting {
  position: relative;
  border: 1.5px solid transparent;
  border-radius: 20px;
}

.extracting::before {
  content: '';
  position: absolute;
  inset: -1.5px;
  border-radius: inherit;
  padding: 1.5px;
  background: conic-gradient(
    from var(--dc-border-angle),
    transparent 0deg,
    var(--mantine-color-brand-6) 90deg,
    var(--mantine-color-brand-5) 160deg,
    transparent 280deg
  );
  -webkit-mask:
    linear-gradient(#000 0 0) content-box,
    linear-gradient(#000 0 0);
  -webkit-mask-composite: xor;
  mask:
    linear-gradient(#000 0 0) content-box,
    linear-gradient(#000 0 0);
  mask-composite: exclude;
  animation: dc-border-rotate 4s linear infinite;
  pointer-events: none;
}

@keyframes dc-border-rotate {
  to {
    --dc-border-angle: 360deg;
  }
}

@media (prefers-reduced-motion: reduce) {
  .extracting::before {
    animation: none;
  }
}
